import {useState} from "react";
import {CheckIcon} from "@heroicons/react/20/solid";
import {ExpenseButtons} from "./Expenses/Buttons";
import ExpenseTabs from "./ExpenseTabs";
import {expensesTotal} from "../utils/utils";
import { Tooltip } from 'react-tooltip'
import {BanknotesIcon, BuildingLibraryIcon} from "@heroicons/react/16/solid";
import * as PropTypes from "prop-types";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function ExpenseName({step}) {
    return <span className="text-sm font-medium text-gray-500 flex items-center gap-2">
        {step.name}
        {step.expenseType === 'recurring' ? (
            <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                Recurring
            </span>
        ) : (
            <span 
                className="inline-flex items-center rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700"
                data-tooltip-id={step.name} 
                data-tooltip-html="Variable expense, calculated as a 12-month average <br/> due to monthly fluctuations."
            >
                Variable
            </span>
        )}
        {step.expenseType !== 'recurring' && (
            <Tooltip id={step.name} style={{"text-align": "center"}} />
        )}
    </span>
}

function TotalExpenseSectionButtons(props) {
    console.log("TotalExpenseSectionButtons:props", props);

    return <>
        <button
            onClick={props.mode === 'demo' ? () => {} : props.onClick}
            type="button"
            className={classNames(
        "mr-3 rounded-full bg-white px-2.5 py-1 text-xs font-semibold shadow-sm ring-1 ring-inset ", props.mode === "demo" ? "ring-gray-300 text-gray-400" : "text-green-900 ring-green-300 hover:bg-green-50")}
        >
            Add Investment
        </button>
        <button
            onClick={props.onClick1}
            type="button"
            className="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-indigo-900 shadow-sm ring-1 ring-inset ring-indigo-300 hover:bg-indigo-50"
        >
            Add Expense Category
        </button>
    </>;
}


TotalExpenseSectionButtons.propTypes = {
    onClick: PropTypes.func,
    onClick1: PropTypes.func
};

export default function Expenses({
                                     mode,
                                     setIsInvestmentPlanSidebarOpen,
                                     expenseStore,
                                     monthlyPassiveIncome,
                                     setIsGuidePopupOpen,
                                     openInsightModal,
                                     expenses,
                                     topExpense,
                                     expensesAsSteps,
                                     updateExpense,
    cumulative,
    setCumulative,
                                     openExpenseForm,
                                 }) {
    const [currentTab, setCurrentTab] = useState('All Expenses')
    
    const handleTabChange = (tabName) => {
        setCurrentTab(tabName)
        // Reset cumulative mode to normal when switching to All Expenses
        if (tabName === 'All Expenses' && cumulative) {
            setCumulative(false)
        }
        // Automatically enable cumulative mode when switching to Cumulative Mode tab
        if (tabName === 'Cumulative Mode' && !cumulative) {
            setCumulative(true)
        }
    }

    console.log('Expenses:monthlyPassiveIncome', monthlyPassiveIncome)

    // Total monthly expenses
    const total = expensesTotal(expensesAsSteps)

    return (
        <nav className="flex flex-1 flex-col" aria-label="Sidebar">
            <div className="flex flex-1 flex-col overflow-y-auto">
                <div className="flex flex-shrink-0 items-center px-4">
                    <div className="flex flex-1 items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <h2 className="text-lg font-semibold text-gray-900">Expenses</h2>
                            <span className="text-sm text-gray-500">${total.toFixed(2)}/month</span>
                        </div>
                        <div className="hidden lg:block">
                            <TotalExpenseSectionButtons mode={mode} onClick={() => {
                                setIsInvestmentPlanSidebarOpen(true)
                            }} onClick1={() => {
                                openExpenseForm(true)
                            }}/>
                        </div>
                        <div className="lg:hidden flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
                            <button
                                onClick={() => setIsInvestmentPlanSidebarOpen(true)}
                                className="inline-flex items-center justify-center rounded-lg border-2 border-indigo-600 bg-transparent px-4 py-2.5 text-sm font-medium text-indigo-600 shadow-sm hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors"
                            >
                                <BuildingLibraryIcon className="mr-2 h-4 w-4" />
                                Add Investment
                            </button>
                            <button
                                onClick={() => openExpenseForm(true)}
                                className="inline-flex items-center justify-center rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors"
                            >
                                <BanknotesIcon className="mr-2 h-4 w-4" />
                                Add Expense
                            </button>
                        </div>
                    </div>
                </div>

                <ExpenseTabs currentTab={currentTab} setCurrentTab={handleTabChange} />
                
                {currentTab === 'All Expenses' && (
                    <div className="space-y-8 p-4 mb-20">
                        {/* Next Milestone Section - All Non-Covered Expenses */}
                        {expensesAsSteps.filter(step => step.status === 'upcoming').length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-600 mr-2">
                                        <span className="h-2.5 w-2.5 rounded-full bg-white"></span>
                                    </span>
                                    Next Milestone
                                </h3>
                                <div className="space-y-3">
                                    {expensesAsSteps
                                        .filter(step => step.status === 'upcoming')
                                        .sort((a, b) => a.amount - b.amount) // Sort from smallest to largest
                                        .map((step) => (
                                        <div key={step.name} className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200 li-expense cursor-pointer" 
                                             onClick={() => openInsightModal(step)}>
                                            <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-600 bg-white mr-4">
                                                <span className="h-2.5 w-2.5 rounded-full bg-gray-600"></span>
                                            </span>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <ExpenseName step={step} />
                                                        <p className="text-sm text-gray-600">{step.description}</p>
                                                    </div>
                                                    <ExpenseButtons step={step} openInsightModal={openInsightModal} 
/>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* In Progress Section */}
                        {expensesAsSteps.filter(step => step.status === 'current').length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 mr-2">
                                        <span className="h-2.5 w-2.5 rounded-full bg-white"></span>
                                    </span>
                                    In Progress
                                </h3>
                                <div className="space-y-3">
                                    {expensesAsSteps
                                        .filter(step => step.status === 'current')
                                        .sort((a, b) => a.amount - b.amount) // Sort from smallest to largest
                                        .map((step) => (
                                        <div key={step.name} className="flex items-center p-4 bg-indigo-50 rounded-lg border border-indigo-200 li-expense cursor-pointer" 
                                             onClick={() => updateExpense(step.expenseId)}>
                                            <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-indigo-600 bg-white mr-4">
                                                <span className="h-2.5 w-2.5 rounded-full bg-indigo-600"></span>
                                            </span>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <ExpenseName step={step} />
                                                        <p className="text-sm text-indigo-700">{step.description}</p>
                                                    </div>
                                                    <ExpenseButtons step={step} openInsightModal={openInsightModal} 
/>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Covered Section */}
                        {expensesAsSteps.filter(step => step.status === 'complete').length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                                    <CheckIcon className="h-5 w-5 text-green-600 mr-2" />
                                    Covered
                                </h3>
                                <p className="text-sm text-gray-600 mb-4">
                                    Expenses where your monthly passive income exceeds the monthly cost
                                </p>
                                <div className="space-y-3">
                                    {expensesAsSteps.filter(step => step.status === 'complete').map((step) => (
                                        <div key={step.name} className="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200 li-expense cursor-pointer" 
                                             onClick={() => updateExpense(step.expenseId)}>
                                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-green-600 mr-4">
                                                <CheckIcon className="h-5 w-5 text-white" />
                                            </span>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <ExpenseName step={step} />
                                                        <p className="text-sm text-gray-600">{step.description}</p>
                                                    </div>
                                                    <ExpenseButtons step={step} openInsightModal={openInsightModal} 
/>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Total Expression Item */}
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            <div className="flex items-center p-4 bg-blue-50 rounded-lg border border-blue-200 li-expense cursor-pointer" 
                                 onClick={() => openInsightModal({
                                     name: 'Total Monthly Expenses',
                                     entries: [{ costInCents: total * 100 }],
                                     description: 'Combined total of all monthly expenses',
                                     expenseType: 'total',
                                     status: 'total'
                                 })}>
                                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 mr-4">
                                    <span className="text-white font-bold text-sm">$</span>
                                </span>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <span className="text-sm font-medium text-gray-900">Total Monthly Expenses</span>
                                            <p className="text-sm text-blue-700">Combined total of all monthly expenses</p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <span className="text-lg font-semibold text-blue-900">${total.toFixed(2)}/month</span>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    openInsightModal({
                                                        name: 'Total Monthly Expenses',
                                                        entries: [{ costInCents: total * 100 }],
                                                        description: 'Combined total of all monthly expenses',
                                                        expenseType: 'total',
                                                        status: 'total'
                                                    })
                                                }}
                                                type="button"
                                                className="inline-flex items-center justify-center rounded bg-indigo-200 px-3 py-2 text-sm font-medium text-indigo-700 shadow-sm ring-1 ring-inset ring-indigo-300 hover:bg-indigo-300 w-12 h-12"
                                            >
                                                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                
                {currentTab === 'Cumulative Mode' && (
                    <div className="space-y-8 p-4 mb-20">
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm font-medium text-blue-800">
                                        Cumulative Mode
                                    </h3>
                                    <div className="mt-2 text-sm text-blue-700">
                                        <p>
                                            In cumulative mode, expenses are covered sequentially. Each expense must be fully covered by the remaining passive income after previous expenses have been covered.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="mb-4">
                            <h3 className="text-lg font-semibold text-gray-900">Cumulative Coverage</h3>
                            <p className="text-sm text-gray-600 mt-1">
                                Expenses are processed sequentially from smallest to largest
                            </p>
                        </div>
                        
                        <div className="space-y-4">
                            {expensesAsSteps.map((step, index) => {
                                const isCovered = step.status === 'complete';
                                const isCurrent = step.status === 'current';
                                
                                return (
                                    <div 
                                        key={step.expenseId} 
                                        className={`flex items-center p-4 rounded-lg border cursor-pointer transition-colors ${
                                            isCovered ? 'bg-green-50 border-green-200 hover:bg-green-100' :
                                            isCurrent ? 'bg-indigo-50 border-indigo-200 hover:bg-indigo-100' :
                                            'bg-gray-50 border-gray-200 hover:bg-gray-100'
                                        }`}
                                        onClick={() => updateExpense(step.expenseId)}
                                    >
                                        <div className="flex-shrink-0 mr-4">
                                            <div className={`flex h-8 w-8 items-center justify-center rounded-full ${
                                                isCovered ? 'bg-green-600' :
                                                isCurrent ? 'bg-indigo-600' :
                                                'bg-gray-600'
                                            }`}>
                                                {isCovered ? (
                                                    <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                ) : (
                                                    <span className="h-2.5 w-2.5 rounded-full bg-white"></span>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center justify-between">
                                                <div>
                                                    <h4 className="text-sm font-medium text-gray-900">
                                                        {step.name}
                                                    </h4>
                                                    <p className="text-sm text-gray-600">
                                                        {step.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Total Expression Item for Cumulative Mode */}
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            <div className="flex items-center p-4 bg-blue-50 rounded-lg border border-blue-200 li-expense cursor-pointer" 
                                 onClick={() => openInsightModal({
                                     name: 'Total Monthly Expenses',
                                     entries: [{ costInCents: total * 100 }],
                                     description: 'Combined total of all monthly expenses',
                                     expenseType: 'total',
                                     status: 'total'
                                 })}>
                                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 mr-4">
                                    <span className="text-white font-bold text-sm">$</span>
                                </span>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <span className="text-sm font-medium text-gray-900">Total Monthly Expenses</span>
                                            <p className="text-sm text-blue-700">Combined total of all monthly expenses</p>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <span className="text-lg font-semibold text-blue-900">${total.toFixed(2)}/month</span>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    openInsightModal({
                                                        name: 'Total Monthly Expenses',
                                                        entries: [{ costInCents: total * 100 }],
                                                        description: 'Combined total of all monthly expenses',
                                                        expenseType: 'total',
                                                        status: 'total'
                                                    })
                                                }}
                                                type="button"
                                                className="inline-flex items-center justify-center rounded bg-indigo-200 px-3 py-2 text-sm font-medium text-indigo-700 shadow-sm ring-1 ring-inset ring-indigo-300 hover:bg-indigo-300 w-12 h-12"
                                            >
                                                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                )}
            </div>
        </nav>
    )
}
